import {BookId} from "./BookId";
import {StoryBronteSisters} from "./StoryBronteSisters";
import {StoryCharlesDickens} from "./StoryCharlesDickens";
import {StoryMaryShelley} from "./StoryMaryShelley";
import {AnyStoryModel} from "./StoryModel";
import {StoryNellieBly} from "./StoryNellieBly";
import {StoryZoraHurston} from "./StoryZoraHurston";

export interface IBookData {
    readonly bookId: BookId;
    readonly story: AnyStoryModel;
    readonly storyText: string;
    readonly storyVO?: string | string[];
    readonly author: string;
    readonly authorVO: string;
}

export const BooksData: IBookData[] = [
    {
        bookId: BookId.Bronte,
        story: StoryBronteSisters,
        storyText: "There are many ways to come up with story ideas.",
        storyVO: "sel_bronte",
        author: "The Bronte Sisters",
        authorVO: "menu_yadina_006",
    },
    {
        bookId: BookId.Dickens,
        story: StoryCharlesDickens,
        storyText: "Your imagination makes everything more fun.",
        storyVO: "sel_dickens_short",
        author: "Charles Dickens",
        authorVO: "menu_xavier_005",
    },
    {
        bookId: BookId.Shelley,
        story: StoryMaryShelley,
        storyText: "Tell stories your own way.",
        storyVO: "sel_shelley",
        author: "Mary Shelley",
        authorVO: "menu_xavier_004",
    },
    {
        bookId: BookId.Hurston,
        story: StoryZoraHurston,
        storyText: "Stories are best when you share them with others.",
        storyVO: "sel_hurston_short",
        author: "Zora Neale Hurston",
        authorVO: "menu_brad_004",
    },
    {
        bookId: BookId.Bly,
        story: StoryNellieBly,
        storyText: "When you really want to do something, be bold.",
        storyVO: "sel_bly",
        author: "Nellie Bly",
        authorVO: "menu_xavier_006",
    },
];
